const getUndoRedoState = (payload, store = {}) => {
  const { reducer: reducerName } = payload

  const { getState } = store

  const state = getState()
  const reducerState = state[reducerName] || {}

  // Create new array with payload added
  const { undo, redo } = reducerState.undoRedoActions || {}

  return {
    redo: [...redo],
    undo: [...undo],
  }
}

export const addAction = (key, payload, store = {}) => {
  const { updateStateType } = payload
  const { dispatch, getState } = store

  const updatedUndoRedo = { ...getUndoRedoState(payload, { dispatch, getState }) }
  updatedUndoRedo[key].push(payload)

  return dispatch({
    type: updateStateType,
    payload: {
      undoRedoActions: updatedUndoRedo,
    },
  })
}

export const removeAction = (key, payload, payloadIndex, store = {}) => {
  const { updateStateType } = payload
  const { dispatch, getState } = store

  const updatedUndoRedo = { ...getUndoRedoState(payload, { dispatch, getState }) }
  updatedUndoRedo[key].splice(payloadIndex, 1)

  return dispatch({
    type: updateStateType,
    payload: {
      undoRedoActions: updatedUndoRedo,
    },
  })
}

export default getUndoRedoState
